export default {
  development: 'http://localhost:3080',
  production: 'https://gamma.qmkey.com/backend',
};
